import merge from 'lodash.merge';
import type { MarkingProps } from 'react-native-calendars/src/calendar/day/marking';
import getOffsetColor from './getOffsetColor';

type CalendarMarkColor = {
  startingDay: string;
  endingDay: string;
  rangeDay: string;
};

export default function getCalendarMarks(
  marked: string[],
  selected: string[],
  colors: CalendarMarkColor,
) {
  const markedSet = new Set([...marked]);
  const selectedSet = new Set([...selected]);
  const rangeDayOffsetColor = getOffsetColor(colors.rangeDay, true);
  const startingDayOffsetColor = getOffsetColor(colors.startingDay, true);
  const endingDayOffsetColor = getOffsetColor(colors.endingDay, true);

  const markedObj = [...markedSet].reduce<{ [key: string]: MarkingProps }>(
    (accumulator, value) => {
      if (marked.includes(value)) {
        accumulator[value] = {
          ...accumulator[value],
          marked: true,
        };
      }
      return accumulator;
    },
    {},
  );

  const selectedObj = [...selectedSet].reduce<{ [key: string]: MarkingProps }>(
    (accumulator, value, index) => {
      if (selected.includes(value)) {
        accumulator[value] = {
          ...accumulator[value],
          color: colors.rangeDay,
          dotColor: rangeDayOffsetColor,
          selected: true,
        };
      }

      if (index === 0) {
        accumulator[value] = {
          ...accumulator[value],
          color: colors.startingDay,
          dotColor: startingDayOffsetColor,
          startingDay: true,
        };
      }

      if (index === selectedSet.size - 1) {
        accumulator[value] = {
          ...accumulator[value],
          color: colors.endingDay,
          dotColor: endingDayOffsetColor,
          endingDay: true,
        };
      }

      return accumulator;
    },
    {},
  );

  return merge(selectedObj, markedObj);
}
